<template>
    <div class="login">
        <div>
            <div>登录账号</div>
            <div>
                <img src="../../assets/logo.jpg">
            </div>
            <div class="pointer" @click="login">立即登录</div>
            <div>已有账号？立即登录</div>
        </div>
        <div>
            <div class="input">
                <el-input style="width: 100%;" placeholder="请输入手机号" v-model="telnum"></el-input>
            </div>
            <div class="input2">
                <el-input placeholder="请输入图形验证码" v-model="imgCode"></el-input>
                <el-button v-show="!codeImg" type="danger" size="medium" @click="getCodeImg">获取验证码</el-button>
                <div class="code" v-show="codeImg" @click="getCodeImg">
                    <img :src="codeImg">
                </div>
            </div>
            <div class="input2">
                <el-input placeholder="请输入短信验证码" v-model="verificationCode"></el-input>
                <el-button v-if="num==60||num==0" type="danger" size="medium" @click="getCode">获取验证码</el-button>
                <div class="code time" v-if="num!=60&&num!=0">
                    {{num}}
                </div>
            </div>
            <div class="input">
                <el-input type="password" placeholder="请输入密码" v-model="pwd" show-password></el-input>
            </div>
            <div class="pointer" @click="registerSave">确定修改</div>
        </div>
    </div>
</template>

<script>
    var timer;
    export default {
        name: 'ForgetPwd',
        data() {
            return {
                input: null,

                codeImg: null,

                imgCode: null,
                verificationCode: null,

                telnum: null,
                nickname: null,
                pwd: null,

                flag: '',

                checked: false,
                num: 60
            }
        },
        methods: {
            login() {
                this.$router.replace({
                    path: '/login'
                })
            },
            registerSave() {
                var reg = /^1[3456789]\d{9}$/;
                if (!this.telnum) {
                    this.$message({
                        message: '请输入手机号',
                        type: 'warning'
                    });
                    return false;
                }
                if (this.telnum.length != 11 || reg.test(this.telnum) == false) {
                    this.$message({
                        message: '手机号码格式不正确，请检查',
                        type: 'warning'
                    });
                    return false;
                }
                if (!this.verificationCode) {
                    this.$message({
                        message: '请输入获取到的短信验证码',
                        type: 'warning'
                    });
                    return false;
                }
                if (!this.pwd) {
                    this.$message({
                        message: '请输入密码',
                        type: 'warning'
                    });
                    return false;
                }
                if (this.pwd.length < 6) {
                    this.$message({
                        message: '密码不能少于6位',
                        type: 'warning'
                    });
                    return false;
                }
                if (this.pwd.length > 18) {
                    this.$message({
                        message: '密码不能大于18位',
                        type: 'warning'
                    });
                    return false;
                }
                if (this.pwd.indexOf(" ") != -1) {
                    this.$message({
                        message: '您输入的密码不能有空格，请检查',
                        type: 'warning'
                    });
                    return false;
                }
                var pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{6,18}');
                if (!pwdRegex.test(this.pwd)) {
                    this.$message({
                        message: '您的密码复杂度太低（密码中必须包含字母、数字）！',
                        type: 'warning'
                    });
                    return false;
                }
                let params = {
                    telephone: this.telnum,
                    code: this.verificationCode,
                    PWD: this.pwd,
                    flag: this.flag
                }
                this.request({
                    method: 'post',
                    url: this.$store.state.httpUrl + "mobileInterf/verifyPassword",
                    params
                }).then(res => {
                    if (res.status == 200) {
                        this.goRouter('/login');
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            getCode() {
                let that = this;
                if (!this.imgCode) {
                    this.$message({
                        message: '图片验证码不能为空',
                        type: 'warning'
                    });
                }
                var reg = /^1[3456789]\d{9}$/;
                if (!this.telnum) {
                    this.$message({
                        message: '请输入手机号',
                        type: 'warning'
                    });
                    return false;
                }
                if (this.telnum.length != 11 || reg.test(this.telnum) == false) {
                    this.$message({
                        message: '手机号码格式不正确，请检查',
                        type: 'warning'
                    });
                    return false;
                }

                timer = setInterval(function() {
                    that.num = that.num - 1;
                    if (that.num == 0) {
                        window.clearInterval(timer);
                        that.num = 60;
                    }
                }, 1000)

                let params = {
                    code: this.imgCode,
                    telephone: this.telnum,
                }
                this.request({
                    method: 'post',
                    url: this.$store.state.httpUrl + "mobileInterf/forgetPWD",
                    params
                }).then(res => {
                    if (res.status == 200) {
                        this.flag = res.data;
                        this.$message({
                            message: '验证码已发送，请注意查收',
                            type: 'success'
                        });
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            //获取验证码图片
            getCodeImg() {
                var reg = /^1[3456789]\d{9}$/;
                if (!this.telnum) {
                    this.$message({
                        message: '请输入手机号',
                        type: 'warning'
                    });
                    return false;
                }
                if (this.telnum.length != 11 || reg.test(this.telnum) == false) {
                    this.$message({
                        message: '手机号码格式不正确，请检查',
                        type: 'warning'
                    });
                    return false;
                }
                this.codeImg = this.$store.state.httpUrl + 'mobileInterf/getAuth?tel=' + this.telnum + '&time=' +
                    new Date().getTime();
            }
        },
        beforeDestroy() {
            window.clearInterval(timer);
        }
    }
</script>

<style scoped>
    .login {
        width: 680px;
        height: 380px;
        margin: 0 auto;
        margin-top: 90px;
        background: #FFFFFF;
        box-shadow: 0px 1px 7px 0px rgba(58, 138, 250, 0.35);
        border-radius: 15px;
        display: flex;
        box-sizing: border-box;
    }

    .login div {
        box-sizing: border-box;
    }

    .login>div:nth-child(1) {
        width: 280px;
        height: 380px;
        background: #D50000;
        border-radius: 15px;
        padding: 0 28px;
        background: url(../../assets/login_bg.png) no-repeat;
        background-size: 100% 100%;
    }

    .login>div:nth-child(1)>div {
        text-align: center;
    }

    .login>div:nth-child(1)>div:nth-child(1) {
        font-size: 18px;
        font-weight: bold;
        color: #FFFFFF;
        padding-bottom: 20px;
        margin-top: 58px;
        position: relative;
    }

    .login>div:nth-child(1)>div:nth-child(1)::before {
        content: ' ';
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        height: 1px;
        background: #FFFFFF;
        opacity: 0.33;
    }

    .login>div:nth-child(1)>div:nth-child(2)>img {
        width: 100px;
        height: 28px;
        margin-top: 80px;
    }

    .login>div:nth-child(1)>div:nth-child(3) {
        width: 160px;
        height: 42px;
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid #FFFFFF;
        border-radius: 8px;
        line-height: 36px;
        font-size: 14px;
        color: #FFFFFF;
        margin: 0 auto;
        margin-top: 28px;
    }

    .login>div:nth-child(1)>div:nth-child(4) {
        font-size: 14px;
        font-weight: 300;
        color: #FFFFFF;
        margin-top: 18px;
    }

    .login>div:nth-child(2) {
        width: 400px;
        height: 380px;
        background: #FFFFFF;
        padding: 10px 36px;
        border-radius: 15px;
    }

    .login>div:nth-child(2)>.input {
        margin-top: 20px;
    }

    .login>div:nth-child(2)>.input2 {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    .login>div:nth-child(2)>.input2>.code {
        width: 96px;
        height: 40px;
        cursor: pointer;
        text-align: center;
        box-sizing: border-box;
        border-radius: 4px;
    }

    .login>div:nth-child(2)>.input2>.time {
        line-height: 36px;
        background: #EBEBEB;
        color: #666666;
    }

    .login>div:nth-child(2)>.input2>.code>img {
        height: 100%;
    }

    .login>div:nth-child(2)>.input2 .el-input {
        width: 220px;
    }

    .login>div:nth-child(2)>.input2 .el-button {
        width: 96px;
        box-sizing: border-box;
        padding: 10px 0;
    }

    .login>div:nth-child(2)>div:nth-child(5) {
        width: 328px;
        height: 48px;
        background: #D50000;
        border-radius: 5px;
        line-height: 48px;
        font-size: 14px;
        color: #FFFFFF;
        margin-top: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/view/login/forgetPwd.vue